import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeMain from './pages/home-main.js';
import BlogClassic from './pages/blog-classic';
import BlogDetails from './pages/blog-details';
import BlogGrid3Columns from './pages/blog-grid-3columns';
import BlogGridSidebar from './pages/blog-grid-sidebar';
import Page404 from './pages/page-404.js';
import PageAbout from './pages/page-about.js';
import PageContact from './pages/page-contact.js';
import PageFAQ from './pages/page-FAQ.js';
import PageServices from './pages/page-services.js';
import PageServicesDetails from './pages/page-services-details.js';
import PageTeam from './pages/page-team.js';
import PageTeamDetails from './pages/page-team-details.js';
import PortfolioCreative from './pages/portfolio-creative.js';
import PortfolioCreativeCarousel from './pages/portfolio-creative-carousel.js';
import PortfolioGallery from './pages/portfolio-gallery.js';
import PortfolioGrid from './pages/portfolio-grid.js';
import PortfolioMasonry from './pages/portfolio-masonry.js';
import ProjectDetails from './pages/project-details.js';
import PageTemplates from './pages/page-templates.js';
import PagePortfolio from './pages/page-portfolio.js';
import PortfolioDetailsPage from './pages/portfolio-details.js';
import AdminPage from './pages/admin.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeMain />} />
        <Route path="/blog-classic" element={<BlogClassic />} />
        <Route path="/blog-details/:id" element={<BlogDetails />} />
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path="/blog-grid-3column" element={<BlogGrid3Columns />} />
        <Route path="/blog-grid-sidebar" element={<BlogGridSidebar />} />
        <Route path="/page-404" element={<Page404 />} />
        <Route path="/page-about" element={<PageAbout />} />
        <Route path="/page-contact" element={<PageContact />} />
        <Route path="/page-FAQ" element={<PageFAQ />} />
        <Route path="/page-services-details" element={<PageServicesDetails />} />
        <Route path="/page-services" element={<PageServices />} />
        <Route path="/portfolio" element={<PagePortfolio />} />
        <Route path="/portfolio-details/:id" element={<PortfolioDetailsPage />} />
        <Route path="/portfolio-details" element={<PortfolioDetailsPage />} />
        <Route path="/page-team" element={<PageTeam />} />
        <Route path="/page-team-details" element={<PageTeamDetails />} />
        <Route path="/portfolio-creative" element={<PortfolioCreative />} />
        <Route path="/portfolio-creative-carousel" element={<PortfolioCreativeCarousel />} />
        <Route path="/portfolio-gallery" element={<PortfolioGallery />} />
        <Route path="/portfolio-grid" element={<PortfolioGrid />} />
        <Route path="/portfolio-masonry" element={<PortfolioMasonry />} />
        <Route path="/project-details" element={<ProjectDetails />} />
        <Route path="/sablonlar" element={<PageTemplates />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Router>
  );
}

export default App;
